"use client";

import { signup } from "@lib/data/customer";
import { LOGIN_VIEW } from "@modules/account/templates/login-template";
import ErrorMessage from "@modules/checkout/components/error-message";
import Input from "@modules/common/components/input";
import LocalizedClientLink from "@modules/common/components/localized-client-link";
import ButtonCustom from "@modules/layout/components/button-custom";
import { useState } from "react";

type Props = {
  setCurrentView: (view: LOGIN_VIEW) => void;
};

const Register = ({ setCurrentView }: Props) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);

    const formData = new FormData(event.currentTarget);
    const error = await signup(null, formData);

    if (error) setMessage(error);
    setLoading(false);
  };

  return (
    <div className="max-w-sm flex flex-col items-center gap-4" data-testid="register-page">
      <h1 className="text-large-semi uppercase">Đăng ký tài khoản</h1>
      <p className="text-center text-base-regular text-ui-fg-base">
        <span className="text-center text-ui-fg-base text-small-regular mt-6">
          Bạn đã có tài khoản?{" "}
          <button onClick={() => setCurrentView(LOGIN_VIEW.SIGN_IN)} className="text-primary-500">
            Đăng nhập tại đây
          </button>
        </span>
      </p>
      <form className="w-full flex flex-col" onSubmit={handleSubmit}>
        <div className="flex flex-col w-full gap-y-2">
          <Input label="Họ" name="first_name" required autoComplete="given-name" data-testid="first-name-input" />
          <Input label="Tên" name="last_name" required autoComplete="family-name" data-testid="last-name-input" />
          <Input label="Email" name="email" required type="email" autoComplete="email" data-testid="email-input" />
          <Input label="Số điện thoại" name="phone" type="tel" required autoComplete="tel" data-testid="phone-input" />
          <Input
            label="Mật khẩu"
            name="password"
            required
            type="password"
            autoComplete="new-password"
            data-testid="password-input"
          />
        </div>
        <ErrorMessage error={message} data-testid="register-error" />
        <span className="text-center text-[#656C78] text-small-regular mt-6">
          Bằng cách đăng ký, bạn đồng ý với{" "}
          <LocalizedClientLink href="/content/terms-of-use" className="underline">
            Điều khoản Sử dụng
          </LocalizedClientLink>{" "}
          và{" "}
          <LocalizedClientLink href="/content/privacy-policy" className="underline">
            Chính sách Bảo mật
          </LocalizedClientLink>
          .
        </span>
        <ButtonCustom className="w-full mt-6" data-testid="register-button" type="submit" disabled={loading}>
          {loading ? "Đang đăng ký..." : "Đăng ký"}
        </ButtonCustom>
      </form>
    </div>
  );
};

export default Register;
